import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
// import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";

import avatar from "assets/img/skin.png";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
};

const useStyles = makeStyles(styles);

export default function UserProfile() {
  const classes = useStyles();
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card profile>
            <CardAvatar profile>
              <a href="#pablo" onClick={e => e.preventDefault()}>
                <img src={avatar} alt="..." />
              </a>
            </CardAvatar>
            <CardBody profile>
              <h4 className={classes.cardCategory}>CONSULTANTS</h4>
              <h6 className={classes.cardTitle}>
                นางนริศรา งามขจรวิวัฒน์ ผู้อำนวยการโรงพยาบาล
              </h6>
              <h6 className={classes.cardTitle}>
                นายนพดล จริงจิตร ประธานคณะกรรมการพัฒนาคุณภาพโรงพยาบาล
              </h6>
              <h6 className={classes.cardTitle}>
                นายสุตศรัญย์ พรึงลำภู ประธานคณะกรรมการสารสนเทศและจัดการความรู้
              </h6>
              <br></br>
              <h4 className={classes.cardCategory}>PROJECT MANAGER</h4>
              <h6 className={classes.cardTitle}>
                นายธงชัย ทำเผือก หัวหน้ากลุ่มงานดิจิทัลการแพทย์
              </h6>
              <br></br>
              <h4 className={classes.cardCategory}>PROJECT TEAM</h4>
              <h6 className={classes.cardTitle}>
                นายนิธิ ปานดำ นักวิชาการคอมพิวเตอร์ปฏิบัติการ
              </h6>
              <h6 className={classes.cardTitle}>
                นายอรรณพ คงการ นักวิชาการคอมพิวเตอร์
              </h6>
              <h6 className={classes.cardTitle}>
                นางสาวขวัญลดา บุญสิน นักวิชาการสถิติ
              </h6>
              <h6 className={classes.cardTitle}>
                นางสาววรรณภา เกิดแก้ว เจ้าพนักงานธุรการ
              </h6>
              <br></br>
              <h6 className={classes.cardTitle}>
                คณะกรรมการสารสนเทศและจัดการความรู้ (IM)
              </h6>
              <h6 className={classes.cardTitle}>
                คณะกรรมการพัฒนาคุณภาพโรงพยาบาล (HA)
              </h6>
              {/* <p className={classes.description}>
                Don{"'"}t be scared of the truth because we need to restart the
                human foundation in truth And I love you like Kanye loves Kanye
                I love Rick Owens’ bed design but the back is...
              </p> */}
              {/* <Button color="primary" round>
                Follow
              </Button> */}
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
